import { useState } from 'react';
import Col from 'react-bootstrap/Col';
import CurrentQuestion from './CurrentQuestion';
import InfoModal from './InfoModal';
import GenerateBook from './GenerateBook';
import WaitingForReview from './WaitingForReview';
import AddName from './AddName';
import AddCover from './AddCover';
import BookReview from './BookReview';
import WaitingForPrint from './WaitingForPrint';
import AddShippingAddress from './AddShippingAddress';
import BookShipped from './BookShipped';
import Upsell from './Upsell';
import FirstUpsell from './FirstUpsell';
import { useTranslation } from 'react-i18next';
import { useUserData } from '../hooks/useUserData';
import { updateUser } from '../firebase/firebase';

const MainActivity = ({ userQuestions: availableQuestions }) => {
  const [answerSuccessModal, setAnswerSuccessModal] = useState(false);

  const { t } = useTranslation();
  const { userData, loading, userUid, userEmail } = useUserData();

  const firstUnansweredQuestion = availableQuestions?.find(
    (question) => question?.answers?.length === 0
  );
  const atLeastOneQuestionAnswered = availableQuestions?.some(
    (question) => question?.answers?.length > 0
  );

  const allQuestionsAnswered =
    availableQuestions?.filter((question) => question?.answers?.length > 0)
      ?.length === 50;

  async function handleUpsellSeen() {
    try {
      const data = {
        upsell_seen: Math.round(Date.now() / 1000),
      };
      await updateUser({ uid: userUid, data, email: userEmail });
    } catch (error) {
      console.error('Error updating document: ', error);
    }
  }

  async function handleFirstUpsellSeen() {
    try {
      const data = {
        first_upsell_seen: Math.round(Date.now() / 1000),
      };
      await updateUser({ uid: userUid, data, email: userEmail });
    } catch (error) {
      console.error('Error updating document: ', error);
    }
  }

  const renderContent = () => {
    if (loading) {
      return null;
    }
    if (!userData?.name) {
      return <AddName />;
    }
    if (
      atLeastOneQuestionAnswered &&
      !allQuestionsAnswered &&
      !userData?.first_upsell_seen
    ) {
      return <FirstUpsell onPress={handleFirstUpsellSeen} />;
    }
    if (userData?.ship_book) {
      return <BookShipped userData={userData} />;
    }

    if (userData?.ready_for_print_book) {
      if (!userData?.upsell_seen) {
        return <Upsell onPress={handleUpsellSeen} />;
      }

      return <WaitingForPrint />;
    }

    if (userData?.review_book) {
      if (!userData?.cover) {
        return <AddCover userData={userData} />;
      }
      if (!userData?.shipping_address) {
        return <AddShippingAddress />;
      }

      return <BookReview />;
    }
    if (userData?.generate_book) {
      return <WaitingForReview />;
    }
    if (allQuestionsAnswered) {
      return <GenerateBook />;
    }
    if (firstUnansweredQuestion) {
      return (
        <CurrentQuestion
          lastAvailableQuestion={firstUnansweredQuestion}
          onSuccess={() => setAnswerSuccessModal(true)}
        />
      );
    }
  };

  return (
    <Col className="main-activity-container">
      {renderContent()}
      <InfoModal
        visible={answerSuccessModal}
        onHide={() => setAnswerSuccessModal(false)}
        title={t('dashboardScreen.answerSuccessfullyRecorded')}
        text={t('dashboardScreen.nicelyDone')}
      />
    </Col>
  );
};

export default MainActivity;
